var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSlideIzq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D41245",
    fillRule: "nonzero",
    d: "M17 0C7.612 0 0 7.612 0 17s7.612 17 17 17 17-7.612 17-17S26.388 0 17 0zm.837 9L20 11.125 13.625 17.5 20 23.875 17.837 26l-8.462-8.5L17.837 9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSlideIzq);
export default __webpack_public_path__ + "static/media/arrow-slide-izq.451d4d3dc208514994d973a6f5493444.svg";
export { ForwardRef as ReactComponent };